import React from 'react';
import './style';

const TestimonialCard = ({srcUrl, username, userId, tweet}) => {

  const words = tweet.split(/\s+/);

  return (
    <div className='testimonialCardContainer'>
      <div className='testimonialHeader'>

        <img src={srcUrl}
          alt='dp'
          className='Tdp'/>
        <div className='TuserDetails'>
          <h4 className='Tusername'>{username}</h4>
          <p className='TuserId'>{userId}</p>
        </div>
      </div>
            
      <p className='tweet'>
        {words.map((word, index) => {
          if (word.startsWith('@') || word.includes('co.in')) {
            return (
              <span key={index}
                style={{color:'#1D9BF0'}}>
                {word+' '}
              </span>
            );
          }
          else if(word === 'br'){
            return (
              <span key={index}>
                <br/>
                <br/>
              </span>
            )
          } else {
            return <span key={index}>{word + ' '}</span>;
          }
        })}
      </p>
    </div>
  );
}

export default TestimonialCard;